import { render, staticRenderFns } from "./VersionTenants.vue?vue&type=template&id=6eb60c9b"
import script from "./VersionTenants.vue?vue&type=script&lang=js"
export * from "./VersionTenants.vue?vue&type=script&lang=js"
import style0 from "./VersionTenants.vue?vue&type=style&index=0&id=6eb60c9b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports